<template>
  <div class="ruler-content">
    <div class="flag" :style="{ top: topNum * ruleVwWidth + 'px' }"></div>
    <div class="ruler-list" ref="scrollrule">
      <div>
        <div class="ruler-null ruler-null-after">
          <div
            class="ruler-item-null"
            v-for="(item, index) in afterNum"
            :key="index"
          >
          </div>
        </div>
        <div class="ruler-ul">
          <div
            class="ruler-item"
            :class="{ 'ruler-item-10': (index + minNum) % 10 == 0 }"
            v-for="(item, index) in rulerCount"
            :key="index"
          >
            <div class="ruler-num" v-if="(index + minNum) % 10 == 0">{{
              index + minNum
            }}</div>
          </div>
        </div>
        <div class="ruler-null">
          <div
            class="ruler-item-null"
            v-for="(item, index) in beforeNum"
            :key="index"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  name: 'cs-ruler',
  props: {
    // 初始值
    NowNum: {
      type: Number,
      default: 100
    },
    // 最大刻度
    maxNum: {
      type: Number,
      default: 1000
    },
    // 最小刻度
    minNum: {
      type: Number,
      default: 0
    },
    // 指针颜色
    pointerColor: {
      type: String,
      default: 'rgb(97,206,81)'
    },
    // 刻度尺每格宽度
    ruleWidth: {
      type: Number,
      default: 10
    },
    // 字体大小
    numSize: {
      type: Number,
      default: 32
    },
    // 是否启用小数
    ispoint: {
      type: Boolean,
      default: false
    },
    // 每个格子多大
    oneGridValue: {
      type: Number,
      default: 1
    },
    topNum: {
      type: Number,
      default: 4 //指针距离顶部有多个格
    }
  },
  data() {
    return {
      screenWidth: 0,
      afterNum: 10,
      beforeNum: 40,
      spaceWidth: 0
    }
  },
  watch: {},
  computed: {
    ruleVwWidth() {
      let res = (this.ruleWidth * this.screenWidth) / 375
      return res
    },
    rulerCount() {
      return Math.abs(this.maxNum - this.minNum) + 1
    }
  },
  created() {
    this.screenWidth = window.screen.width
    this.$nextTick(() => {
      this.initScroll()
      // this.calculateWidth()
      // this.NowNum - this.minNum 当前值-最小值才是初始化需要滚动的值
      let scrollNum = this.maxNum + this.afterNum - this.NowNum - this.topNum
      console.log(scrollNum * this.ruleVwWidth)
      this.scrollrule.scrollBy(0, -(this.ruleVwWidth * scrollNum), 0)
    })
  },
  mounted() {},
  methods: {
    filterCurNum(number) {
      if (number < this.minNum) {
        number = this.minNum
      } else if (number > this.maxNum) {
        number = this.maxNum
      }
      return number
    },
    // 初始化滚动
    initScroll() {
      this.scrollrule = new BScroll(this.$refs.scrollrule, {
        // 实时监听滚动的位置并返回
        probeType: 3,
        scrollY: true
      })

      // 监听滚动开始
      this.scrollrule.on('scrollStart', () => {
        this.$emit('scroll-start', true)
      })

      // 监听滚动
      this.scrollrule.on('scroll', (pos) => {
        if (pos.y > 0) {
          return
        }
        this.scrollY = Math.abs(Math.round(pos.y))
        let NumValue =
          this.maxNum +
          this.afterNum -
          Math.abs(Math.round(this.scrollY / this.ruleVwWidth)) -
          this.topNum
        this.curNum = this.filterCurNum(NumValue * this.oneGridValue)
        this.$emit('post-NumValue', this.curNum)
      })

      //滚动结束监听
      this.scrollrule.on('scrollEnd', () => {
        //滑动后的小距离
        let littleNum = this.scrollY % this.ruleVwWidth
        let numValue =
          this.maxNum +
          this.afterNum -
          this.topNum -
          Math.abs(Math.round(this.scrollY / this.ruleVwWidth))
        console.log(numValue)
        //计算距离下一个刻度的差值
        let vul = this.ruleVwWidth - littleNum
        if (numValue <= this.maxNum && numValue >= this.minNum) {
          // 加入差值比较大,再进行吸附,大于一半的距离,就往右边吸附差值的距离,小于一半的距离,就往左边吸附滑动的距离
          if (vul > 0.5 && vul < this.ruleVwWidth - 0.5) {
            if (littleNum > this.ruleVwWidth / 2) {
              this.scrollrule.scrollBy(0, -vul, 0)
            } else {
              this.scrollrule.scrollBy(0, littleNum, 0)
            }
          }
        } else if (numValue > this.maxNum) {
          this.scrollrule.scrollTo(
            0,
            -this.ruleVwWidth * (this.afterNum - this.topNum),
            0.2
          )
        } else if (numValue < this.minNum) {
          this.scrollrule.scrollTo(
            0,
            -this.ruleVwWidth *
              (this.maxNum - this.minNum + this.afterNum - this.topNum),
            0.2
          )
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ruler-content {
  height: 100%;
  position: relative;
  overflow: hidden;
  .flag {
    position: absolute;
    width: 0px;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid #6236ff;
    transform: translate(0%, -50%) rotate(90deg);
    z-index: 9;
    left: -2px;
  }
  .ruler-list {
    height: 100%;
    .ruler-ul {
      display: flex;
      flex-direction: column-reverse;

      .ruler-item {
        position: relative;
        width: 20px;
        height: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.8);
      }

      .ruler-item-10 {
        width: 36px;
      }

      .ruler-num {
        position: absolute;
        left: 50px;
        bottom: 0;
        transform: translate(0%, 50%);
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }

    .ruler-null {
      .ruler-item-null {
        width: 20px;
        height: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.8);
      }
    }
    .ruler-null-after {
      .ruler-item-null:first-child {
        display: none;
      }
    }
  }
}
</style>
